module.exports = __webpack_public_path__ + "img/6.7aca6080.png";